import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { hasLeaderboardAccess } from '../../utils/leaderboardAccess';
import { LEADERBOARD_ACCESS_CODE } from '../../config/constants';

const RequireLeaderboardAccess = () => {
  if (!hasLeaderboardAccess(LEADERBOARD_ACCESS_CODE)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default RequireLeaderboardAccess;
